// getUserDataList.js
'use strict';
import { Collection } from 'immutable';
import { createSelector } from '../resource/createCachedSelector.js';

/**
 * Select user data list by user ids
 * @kind selector
 * @param {Immutable.Map} state - root state.
 * @param {array} userIds=[] - user ids.
 * @param {bool} [needUnique=true] - should dedupe message ids
 * @return {RETURN_TYPE} The selected user data list.
 */
const getUserDataList = createSelector(
  state => state.get('users'),
  (state, userIds) => userIds || [],
  (state, userIds, needUnique) => needUnique,
  (users, userIds, needUnique = true) => {
    let ids = userIds;
    if (needUnique) {
      ids = [...new Set(userIds)];
    }
    const result = ids.map(userId => users.get(userId)?.toJS()).filter(a => a);
    return result instanceof Collection ? result.toJS() : result;
  }
);

export default getUserDataList;
